import { styled, Table } from '@mui/material';

interface SidePanelPropsTableProps {
  withDividers?: boolean;
}

export const SidePanelPropsTable = styled(Table, {
  shouldForwardProp: (prop) => prop !== 'withDividers',
})<SidePanelPropsTableProps>(({ withDividers = false }) => ({
  '&': {
    width: '100%',
  },
  '& tr td': {
    padding: withDividers ? '16px 0 16px 40px' : '5px 0 5px 40px',
  },
  '& tr:first-child td': {
    padding: withDividers ? '0 0 16px 40px' : '0 0 5px 40px',
  },
  '& tr:last-child td': {
    padding: withDividers ? '16px 0 0 40px' : '5px 0 0 40px',
  },
  '& tr:not(:last-child)': {
    borderBottom: withDividers
      ? '1px dashed var(--mui-palette-divider)'
      : 'none',
  },
  '& .props-col': {
    width: '170px',
    fontWeight: '400',
    verticalAlign: 'top',
  },
}));
